
import { NB_AUTH_OPTIONS, NbAuthResult, NbAuthService, NbAuthSocialLink} from '@nebular/auth';
import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { getDeepFromObject } from './helper';
import { UserService } from '../../../@core/mock/users.service';



@Component({
  selector: 'nb-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class NgxLoginComponent {

  redirectDelay: number = 0;
  showMessages: any = {};
  provider: string = '';

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  strategy: string = '';
  constructor(protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected config = {},
    protected cd: ChangeDetectorRef,
    private userService: UserService,
    private menuService: NbMenuService,
    protected router: Router,

  ) {

    this.showMessages = this.getConfigValue('forms.login.showMessages');
    this.provider = this.getConfigValue('forms.login.provider');
    this.strategy = this.getConfigValue('forms.login.strategy');
  }

  login(): void {
    this.errors = this.messages = [];
    this.submitted = true;

    this.service.authenticate(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;

      if (result.isSuccess()) {
        this.messages = result.getMessages();
        this.userService.UserLogged = {
          idUsuario: result.getResponse().body.userID,
          idConcesionario: result.getResponse().body.idConcesionario,
          idPerfil: result.getResponse().body.idPerfil,
          name: result.getResponse().body.fullName,
          picture: 'assets/images/man.png'
        };



        var MENU_ITEMS = [

          {
            title: 'Vehículos',
            key: 'Vehiculo',
            icon: 'car-outline',
            children: [
              {
                title: 'Marcas',
                key: 'NuevaMarca',
                //icon: 'fas fa-circle',
                link: '/pages/forms/marcas',
              },
              {
                title: 'Modelos',
                key: 'NuevoModelo',
                //  icon: 'fas fa-circle',
                link: '/pages/forms/modelos',
              },
              {
                title: 'Versiones',
                key: 'NuevoVersion',
                //  icon: 'fas fa-circle',
                link: '/pages/forms/versiones',
              }
              ,
              {
                title: 'Categorías',
                key: 'NuevaCategoria',
                //icon: 'fas fa-circle',
                link: '/pages/forms/categorias',
              },

              {
                title: 'Características',
                key: 'NuevaCaracteristica',
                //icon: 'fas fa-circle',
                link: '/pages/forms/caracteristicas',
              },
              {
                title: 'Usados',
                key: 'NuevoUsado',
               // icon: 'ion-car',
                link: '/pages/forms/vehiculos',
              },

            ],
          },



          {
            title: 'Planes',
            key: 'NuevoPlanes',
            icon: 'file-text-outline',
            link: '/pages/forms/planes',
          },
          /*{
            title: 'Consultas',
            key: 'NuevaConsulta',
            icon: 'message-circle-outline',
            link: '/pages/forms/consultas',
          },*/
          {
            title: 'Mantenimiento',
            key: 'Mantenimiento',
            icon: 'settings-2-outline',
            children: [
              {
                title: 'Usuarios',
                key: 'NuevoUsuario',
                link: '/pages/forms/usuarios',
              },

              {
                title: 'Perfiles',
                key: 'NuevoPerfil',
                link: '/pages/forms/perfil',
              },
            ],
          }
        ];

        localStorage.setItem("MENU_ITEMS", JSON.stringify(MENU_ITEMS));
        localStorage.setItem("USER_LOGGED",
          JSON.stringify(
            {
              idUsuario: result.getResponse().body.userID,
              idConcesionario: result.getResponse().body.idConcesionario,
              idPerfil: result.getResponse().body.idPerfil,
              Permission: result.getResponse().body.permission,
              Role: result.getResponse().body.role,
              name: result.getResponse().body.fullName,
              picture: 'assets/images/man.png'
            }));

      } else {
        this.errors = result.getErrors();
      }
      //userService.users
      const redirect = result.getRedirect();
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);

      }
      this.cd.detectChanges();
    });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.config, key, null);
  }


}




/*

import { NB_AUTH_OPTIONS, NbAuthResult, NbAuthService, NbAuthSocialLink } from '@nebular/auth';
import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../@core/mock/users.service';
import { NbMenuService } from '@nebular/theme';
import { NbMenuItem } from '@nebular/theme';
import { NbAclService } from '@nebular/security';

@Component({
  selector: 'nb-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class NgxLoginComponent {

  redirectDelay: number = 0;
  showMessages: any = {};
  provider: string = '';

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  strategy: string = '';
  constructor(protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected config = {},
    protected cd: ChangeDetectorRef,
    private userService: UserService,
    private menuService: NbMenuService,
    protected router: Router,

  ) {


  }

  login(): void {
    this.errors = this.messages = [];
    this.submitted = true;

    this.service.authenticate(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;

      if (result.isSuccess()) {
        this.messages = result.getMessages();
        this.userService.UserLogged = {
          idUsuario: result.getResponse().body.userID,
          idConcesionario: result.getResponse().body.idConcesionario,
          idPerfil: result.getResponse().body.idPerfil,
          name: result.getResponse().body.fullName,
          picture: 'dashboard/assets/images/man.png'
        };



        var MENU_ITEMS = [

          {
            title: 'Vehículos',
            key: 'Vehiculo',
            icon: 'fas fa-car-alt',
            children: [
              {
                title: 'Marcas',
                key: 'NuevaMarca',
                //   icon: 'fas fa-circle',
                link: '/pages/forms/marcas',
              },
              {
                title: 'Modelos',
                key: 'NuevoModelo',
                //  icon: 'fas fa-circle',
                link: '/pages/forms/modelos',
              },
              {
                title: 'Versiones',
                key: 'NuevoVersion',
                //  icon: 'fas fa-circle',
                link: '/pages/forms/versiones',
              }
              ,
              {
                title: 'Categorías',
                key: 'NuevaCategoria',
                //icon: 'fas fa-circle',
                link: '/pages/forms/categorias',
              },

              {
                title: 'Características',
                key: 'NuevaCaracteristica',
                //icon: 'fas fa-circle',
                link: '/pages/forms/caracteristicas',
              },
              {
                title: 'Usados',
                key: 'NuevoUsado',
                icon: 'fas fa-car-alt',
                link: '/pages/forms/vehiculos',
              },

            ],
          },



          {
            title: 'Planes',
            key: 'NuevoPlanes',
            icon: 'fas fa-file-alt',
            link: '/pages/forms/planes',
          },
          {
            title: 'Consultas',
            key: 'NuevaConsulta',
            icon: 'fas fa-comments',
            link: '/pages/forms/consultas',
          },
          {
            title: 'Mantenimiento',
            key: 'Mantenimiento',
            icon: 'fas fa-cog',
            children: [
              {
                title: 'Usuarios',
                key: 'NuevoUsuario',
                link: '/pages/forms/usuario',
              },

              {
                title: 'Perfiles',
                key: 'NuevoPerfil',
                link: '/pages/forms/perfil',
              },
            ],
          }
        ];

        localStorage.setItem("MENU_ITEMS", JSON.stringify(MENU_ITEMS));
        localStorage.setItem("USER_LOGGED",
          JSON.stringify(
            {
              idUsuario: result.getResponse().body.userID,
              idConcesionario: result.getResponse().body.idConcesionario,
              idPerfil: result.getResponse().body.idPerfil,
              Permission: result.getResponse().body.permission,
              Role: result.getResponse().body.role,
              name: result.getResponse().body.fullName,
              picture: 'dashboard/assets/images/man.png'
            }));

      } else {
        this.errors = result.getErrors();
      }
      //userService.users
      const redirect = result.getRedirect();
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);

      }
      this.cd.detectChanges();
    });
  }


}
*/

/**
 * Extending object that entered in first argument.
 *
 * Returns extended object or false if have no target object or incorrect type.
 *
 * If you wish to clone source object (without modify it), just use empty new
 * object as first argument, like this:
 *   deepExtend({}, yourObj_1, [yourObj_N]);
 */
